import React from "react";
import PropTypes from "prop-types";
import { Column, Field, Control, Label, Input } from "rbx";
import { DateTimePicker } from "../inputs";

import {
  handleChange,
  // handleOrderedOnByChange,
  handleTimeChange,
  handlePickupDateFormattedChange,
  handleRequestedDeliveryDateFormattedChange,
  handleRoundTime
} from "./utils";

function TimeFrames({ order, editing, onChange }) {
  return (
    <React.Fragment>
      <Column.Group>
        <Column size={2}>
          <Field>
            <Control expanded>
              <Label>Est. Load Time (hrs)</Label>
              <Input
                readOnly
                autoComplete="new"
                name="EstimatedLoad"
                type="number"
                value={order.EstimatedLoad}
                onBlur={handleRoundTime(order, onChange)}
                onChange={handleTimeChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control expanded>
              <Label>Est. Travel Time (hrs)</Label>
              <Input
                readOnly
                autoComplete="new"
                name="EstimatedTravel"
                type="number"
                value={order.EstimatedTravel}
                onBlur={handleRoundTime(order, onChange)}
                onChange={handleTimeChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control expanded>
              <Label>Est. Unload Time (hrs)</Label>
              <Input
                readOnly
                autoComplete="new"
                name="EstimatedUload"
                type="number"
                value={order.EstimatedUload}
                onBlur={handleRoundTime(order, onChange)}
                onChange={handleTimeChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control expanded>
              <Label>Loaded Miles</Label>
              <Input
                readOnly
                autoComplete="new"
                name="LoadedMiles"
                type="number"
                value={order.LoadedMiles}
              />
            </Control>
          </Field>
        </Column>
        <Column size={4}>
          <Field>
            <Control>
              <Label>Ordered By</Label>
              <Input
                readOnly
                autoComplete="new"
                name="OrderedBy"
                value={order.CreatedBy}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Order Date</Label>
              <Input
                readOnly
                name="OrderDate"
                type="date"
                value={
                  order?.OrderDate
                    ? new Date(order.OrderDate).toISOString().slice(0, 10)
                    : new Date().toISOString().slice(0, 10)
                }
                onChange={handleChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
        <Column size={3}>
          <Field>
            <Control>
              <Label>{`Requested Delivery Date (${order?.DeliveryLocation?.TimeZone.CodeId})`}</Label>
              <DateTimePicker
                required
                disabled={!editing}
                name="RequestedDeliveryDateFormatted"
                value={order.RequestedDeliveryDateFormatted}
                onChange={handleRequestedDeliveryDateFormattedChange(
                  order,
                  onChange
                )}
              />
            </Control>
          </Field>
        </Column>
        <Column size={3}>
          <Field>
            <Control>
              <Label>
                {`Scheduled Delivery Date (${order?.DeliveryLocation?.TimeZone.CodeId})`}
              </Label>
              <DateTimePicker
                disabled={!editing}
                name="ScheduledDeliveryDateFormatted"
                value={order.ScheduledDeliveryDateFormatted}
                onChange={handleChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
        <Column size={3}>
          <Field>
            <Control>
              <Label>
                {`Pickup Date (${order?.PickupLocation?.TimeZone.CodeId})`}
              </Label>
              <DateTimePicker
                disabled={!editing}
                name="PickupDateFormatted"
                value={order.PickupDateFormatted}
                onChange={handlePickupDateFormattedChange(order, onChange)}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
    </React.Fragment>
  );
}

TimeFrames.propTypes = {
  order: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool
};
export default TimeFrames;
